var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle, _circle2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubethumbnail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 108,
    viewBox: "0 0 204 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 108,
    rx: 8,
    fill: "#EEF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 79.4883C160 84.565 159.159 89.4399 157.617 94H70.3835C68.8407 89.4399 68 84.565 68 79.4883C68 74.0726 68.955 68.8749 70.7181 64.0565C77.1012 46.5262 94.0712 34 114.004 34C132.533 34 148.499 44.8232 155.788 60.4407C158.498 66.2357 160 72.6844 160 79.4883Z",
    fill: "#A5F9A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181 94H123C124.677 79.93 137.02 69 152 69C152.755 69 153.504 69.024 154.24 69.0779C168.198 70.1086 179.41 80.6371 181 94Z",
    fill: "#D0DFFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 94H17C19.1104 75.4276 34.6465 61 53.5 61C59.1849 61 64.5582 62.313 69.3631 64.6465C80.4993 70.0726 88.5282 81.0278 90 94Z",
    fill: "#D0DFFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2939 50.1502L70.0927 49.4083C70.0927 43.9856 65.6968 39.5898 60.2742 39.5898C58.466 39.5898 57 41.0558 57 42.8641V73.3948C57 82.8252 62.305 91.0151 70.0927 95.1471L70.2939 94.2646V50.1502Z",
    fill: "#FFC0A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5059 40.5469V91.0824C66.1622 92.6844 68.0407 94.0582 70.094 95.1478V49.409C70.094 45.5014 67.8107 42.1274 64.5059 40.5469Z",
    fill: "#FFAD85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.553 47.3839C146.529 44.1833 143.103 42.4191 139.903 43.4436L126.004 47.8925V58.8398H129.823C130.3 58.8398 130.762 58.8981 131.206 59.0054L143.613 55.034C146.814 54.0096 148.578 50.5845 147.553 47.3839Z",
    fill: "#FFC0A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.551 47.3842C146.88 45.288 145.18 43.8081 143.187 43.3242C143.959 46.4105 142.212 49.6077 139.139 50.5914L126.002 54.7962V58.8401H129.821C130.298 58.8401 130.76 58.8984 131.204 59.0057L143.611 55.0343C146.812 54.0099 148.576 50.5848 147.551 47.3842Z",
    fill: "#FFAD85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.149 104H81.1481C76.1475 104 72.0938 99.9461 72.0938 94.9455V13.0543C72.0938 8.05371 76.1475 4 81.1481 4H120.149C125.15 4 129.203 8.05371 129.203 13.0543V94.9455C129.203 99.9461 125.15 104 120.149 104Z",
    fill: "#0032C7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.149 104H78.1481C73.1475 104 69.0938 99.9461 69.0938 94.9455V13.0543C69.0938 8.05371 73.1475 4 78.1481 4H117.149C122.15 4 126.203 8.05371 126.203 13.0543V94.9455C126.203 99.9461 122.15 104 117.149 104Z",
    fill: "#245DFB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M120.037 64.8711H75.2599C71.8545 64.8711 69.094 67.6315 69.0938 71.0369V94.9453C69.094 99.9457 73.1477 103.999 78.1481 103.999H117.149C122.149 103.999 126.203 99.9459 126.203 94.9459V71.0373C126.203 67.6319 123.443 64.8711 120.037 64.8711Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6857 76.775C88.6857 77.9532 89.6409 78.9083 90.8191 78.9083C91.9973 78.9083 92.9524 77.9532 92.9524 76.775C92.9524 75.5968 91.9973 74.6417 90.8191 74.6417C89.6409 74.6417 88.6857 75.5968 88.6857 76.775ZM92.6839 62.6015C91.2111 62.7315 89.3484 63.643 88.5307 65.9228C87.7217 68.1782 87.9696 71.6833 90.4574 76.946L91.1807 76.604C88.7285 71.4167 88.5806 68.1531 89.2837 66.1929C89.9781 64.257 91.5354 63.506 92.7542 63.3985L92.6839 62.6015Z",
    fill: "#0032C7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.931 75.8253L102.828 76.2118L103.151 76.2979L103.293 75.9953L102.931 75.8253ZM98.0244 80.2693C97.9865 80.4869 98.1323 80.694 98.3499 80.7319C98.5676 80.7697 98.7747 80.624 98.8125 80.4063L98.0244 80.2693ZM102.393 63.6328C103.21 63.7635 104.298 64.4515 104.683 66.2431C105.074 68.0616 104.739 71.0329 102.569 75.6553L103.293 75.9953C105.493 71.3077 105.91 68.1436 105.465 66.075C105.015 63.9795 103.681 63.0287 102.519 62.8428L102.393 63.6328ZM103.034 75.4388C102.336 75.2528 101.274 75.3013 100.284 75.9967C99.2889 76.6961 98.4168 78.0125 98.0244 80.2693L98.8125 80.4063C99.1801 78.2931 99.9705 77.1949 100.744 76.6514C101.524 76.1038 102.338 76.0812 102.828 76.2118L103.034 75.4388Z",
    fill: "#0032C7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 100 80)",
    fill: "#0032C7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 105 81)",
    fill: "#0032C7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.602 81.7731C102.476 81.9551 102.522 82.2042 102.705 82.3293C102.887 82.4545 103.136 82.4084 103.261 82.2263L102.602 81.7731ZM102.662 76.1207C103.399 76.7908 104.568 78.9133 102.602 81.7731L103.261 82.2263C105.475 79.0061 104.205 76.442 103.2 75.5287L102.662 76.1207Z",
    fill: "#0032C7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.037 64.8711H118.622V88.6159C118.622 93.061 115.018 96.6642 110.574 96.6642H69.2588C70.0622 100.842 73.7356 103.999 78.1479 103.999H117.149C122.149 103.999 126.203 99.9457 126.203 94.9457V71.0373C126.203 67.6319 123.443 64.8711 120.037 64.8711Z",
    fill: "#E6EEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.223 61.8064H95.0736C94.1148 61.8064 93.1873 61.6732 92.3052 61.4289V64.8712L96.9275 71.3728C97.3038 71.9019 98.0911 71.8985 98.4625 71.3657L102.992 64.871V61.4287C102.11 61.6732 101.182 61.8064 100.223 61.8064Z",
    fill: "#FFC0A0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6596 39.5753H84.6828V37.3325C84.6828 31.7701 89.2081 27.2448 94.7705 27.2448H100.525C106.087 27.2448 110.612 31.7701 110.612 37.3325V39.5753H115.636C115.951 39.5753 116.259 39.6111 116.555 39.6771V37.3325C116.555 28.4937 109.364 21.3027 100.525 21.3027H94.7705C85.9317 21.3027 78.7407 28.4937 78.7407 37.3325V39.6771C79.0369 39.6111 79.3439 39.5753 79.6596 39.5753Z",
    fill: "#AEC5F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.437 21.5728C104.357 23.1124 104.887 24.9122 104.887 26.8361V28.2375C108.272 29.8671 110.613 33.3315 110.613 37.3327V39.5755H115.637C115.952 39.5755 116.259 39.6113 116.555 39.6773V37.3327C116.555 29.4882 110.89 22.9464 103.437 21.5728Z",
    fill: "#86A8EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6822 39.3887H79.6588C77.222 39.3887 75.2466 41.3641 75.2466 43.8009V46.4848C75.2466 48.9216 77.222 50.8971 79.6588 50.8971H84.6822V39.3887Z",
    fill: "#AEC5F4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.636 39.3887H110.612V50.8973H115.636C118.072 50.8973 120.048 48.9219 120.048 46.485V43.8011C120.048 41.3641 118.072 39.3887 115.636 39.3887Z",
    fill: "#AEC5F4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.223 61.9937H95.0732C89.2314 61.9937 84.4956 57.2579 84.4956 51.416V37.3326C84.4956 31.6575 89.0962 27.0571 94.771 27.0571H100.525C106.2 27.0571 110.801 31.6577 110.801 37.3326V51.416C110.801 57.2581 106.065 61.9937 100.223 61.9937Z",
    fill: "#FFC0A0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.886 28.0283V52.8782C104.886 56.7617 102.792 60.1544 99.6729 61.9938H100.223C106.065 61.9938 110.801 57.258 110.801 51.4162V37.3327C110.801 33.2174 108.38 29.669 104.886 28.0283Z",
    fill: "#FFAD85"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.526 27.0576H94.7715C89.0965 27.0576 84.4961 31.6582 84.4961 37.333V38.8809C86.7389 38.664 88.7391 37.6208 90.1878 36.0574C90.4273 35.799 90.8353 35.7842 91.0741 36.0431C92.7083 37.8151 95.048 38.9262 97.6486 38.9262C100.249 38.9262 102.589 37.8151 104.223 36.0431C104.462 35.7842 104.87 35.799 105.109 36.0574C106.558 37.6208 108.558 38.664 110.801 38.8809V37.333C110.801 31.658 106.201 27.0576 100.526 27.0576Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.1 9.45849C136.633 9.78827 131.377 15.0241 131.02 21.4895C130.874 24.1406 131.54 26.6255 132.788 28.724C132.908 28.9259 132.939 29.1679 132.865 29.3906L131.438 33.6677C131.243 34.2504 131.753 34.8252 132.354 34.7023L137.66 33.6184C137.834 33.583 138.013 33.6085 138.172 33.6862C140.102 34.6297 142.303 35.1041 144.63 34.9504C151.048 34.5266 156.209 29.2733 156.522 22.8486C156.89 15.2826 150.67 9.07237 143.1 9.45849Z",
    fill: "#0032C7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.1 8.45849C135.633 8.78827 130.377 14.0241 130.02 20.4895C129.874 23.1406 130.54 25.6255 131.788 27.724C131.908 27.9259 131.939 28.1679 131.865 28.3906L130.438 32.6677C130.243 33.2504 130.753 33.8252 131.354 33.7023L136.66 32.6184C136.834 32.583 137.013 32.6085 137.172 32.6862C139.102 33.6297 141.303 34.1041 143.63 33.9504C150.048 33.5266 155.209 28.2733 155.522 21.8486C155.89 14.2826 149.67 8.07237 142.1 8.45849Z",
    fill: "#245DFB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.869 64.7236C118.869 61.363 121.593 58.6387 124.954 58.6387H129.822C133.183 58.6387 135.907 61.363 135.907 64.7236C135.907 68.0841 133.183 70.8085 129.822 70.8085H124.954C121.593 70.8085 118.869 68.0841 118.869 64.7236Z",
    fill: "#FFC0A0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M131.435 58.8555V60.2865C131.435 63.647 128.711 66.3713 125.35 66.3713H119.098C119.817 68.9305 122.166 70.8076 124.955 70.8076H129.823C133.183 70.8076 135.907 68.0832 135.907 64.7227C135.907 61.9207 134.013 59.5625 131.435 58.8555Z",
    fill: "#FFAD85"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M118.869 76.8915C118.869 73.531 121.593 70.8066 124.954 70.8066H129.822C133.183 70.8066 135.907 73.531 135.907 76.8915C135.907 80.2521 133.183 82.9764 129.822 82.9764H124.954C121.593 82.9764 118.869 80.2521 118.869 76.8915Z",
    fill: "#FFC0A0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M131.435 71.0254V72.4564C131.435 75.8169 128.711 78.5413 125.35 78.5413H119.098C119.817 81.1004 122.166 82.9775 124.955 82.9775H129.823C133.183 82.9775 135.907 80.2531 135.907 76.8926C135.907 74.0906 134.013 71.7324 131.435 71.0254Z",
    fill: "#FFAD85"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.869 89.0615C118.869 85.7009 121.593 82.9766 124.954 82.9766H129.822C133.183 82.9766 135.907 85.7009 135.907 89.0615C135.907 92.422 133.183 95.1464 129.822 95.1464H124.954C121.593 95.1464 118.869 92.422 118.869 89.0615Z",
    fill: "#FFC0A0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M131.435 83.1953V84.6263C131.435 87.9869 128.711 90.7112 125.35 90.7112H119.098C119.817 93.2703 122.166 95.1474 124.955 95.1474H129.823C133.183 95.1474 135.907 92.4231 135.907 89.0625C135.907 86.2605 134.013 83.9024 131.435 83.1953Z",
    fill: "#FFAD85"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5098 44.2109V45.2385",
    stroke: "#FF8B52",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.785 44.2109V45.2385",
    stroke: "#FF8B52",
    strokeWidth: 3.0181,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9492 52.8281C95.9939 54.8728 99.3029 54.8728 101.348 52.8281",
    stroke: "#FF8B52",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M95.542 101.084C100.26 101.084 104.084 97.2597 104.084 92.542C104.084 87.8244 100.26 84 95.542 84C90.8244 84 87 87.8244 87 92.542C87 97.2597 90.8244 101.084 95.542 101.084Z",
    fill: "#A5F9A6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8005 84.0933C98.077 85.586 98.8496 87.5224 98.8496 89.6403C98.8496 94.358 95.0253 98.1824 90.3076 98.1824C89.8798 98.1824 89.4597 98.15 89.0488 98.0892C90.6154 99.9212 92.9422 101.084 95.5418 101.084C100.259 101.084 104.084 97.2598 104.084 92.5421C104.084 88.2524 100.921 84.7021 96.8005 84.0933Z",
    fill: "#70F571"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4994 94.6251C97.7399 95.3846 96.5083 95.3846 95.7487 94.6251L93.4564 92.3327C92.6968 91.5732 92.6968 90.3416 93.4564 89.582",
    stroke: "#245DFB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M94 10H109",
    stroke: "#0032C7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90 10H90.0001",
    stroke: "#0032C7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M63 31H31C31 27.8305 33.4817 25.2561 36.537 25.2561C37.4349 25.2561 38.2829 25.4761 39.0312 25.8771C40.7147 22.9534 43.7825 21 47.3118 21C50.7412 21 53.7467 22.8499 55.4552 25.6442C56.0787 25.3855 56.7646 25.2432 57.4754 25.2432C60.5183 25.2561 63 27.8176 63 31Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M165.374 40.0584C161.584 40.0584 151.364 40.0384 148.554 39.9584C148.164 39.9484 147.904 39.5584 148.034 39.1884C148.494 37.9684 149.514 36.9584 150.744 36.5384C152.214 36.0384 153.954 36.3984 155.104 37.4484C156.234 35.0884 159.014 33.6384 161.594 34.0784C163.754 34.4484 165.604 36.0984 166.434 38.5384C166.694 39.2884 166.154 40.0584 165.374 40.0584Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5822 81.7031L19.9922 94.0002H31.1622L25.5822 81.7031Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 73L8 93.9999H22.52L15.26 73Z",
    fill: "#A5F9A6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M170.58 81.7031L176.17 94.0002H165L170.58 81.7031Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M180.902 73L188.162 93.9999H173.642L180.902 73Z",
    fill: "#A5F9A6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M143 16V26",
    stroke: "white",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M138 21H148",
    stroke: "white",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubethumbnail2);
export default __webpack_public_path__ + "static/media/Youtube thumbnail2.ab12b75a87788d9dcfd3885127ce4af2.svg";
export { ForwardRef as ReactComponent };